import { NavLink } from "react-router-dom";
import { Link } from "@material-ui/core";

export function BrandLink(props) {
    return (
        <Link component={NavLink} {...props} />
    );
}
